import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgregarFichaComponent } from './agregar-ficha/agregar-ficha.component';
import { ListaFichasComponent } from './lista-fichas/lista-fichas.component';
import { MainFichaComponent } from './main-ficha/main-ficha.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSortModule } from '@angular/material/sort';
import { HelperModule } from 'src/app/helper.module';
import { CalendarModule } from 'primeng/calendar';
import { PrimeNgModule } from 'src/app/PrimeNg.module';
import { AutonumericModule } from '@angularfy/autonumeric';



@NgModule({
  declarations: [
    AgregarFichaComponent,
    ListaFichasComponent,
    MainFichaComponent
  ],
  imports: [
      CommonModule,
      MaterialModule,
      FormsModule,
      MatDatepickerModule,
      MatSortModule,
      HelperModule,
      CalendarModule,
      PrimeNgModule,
      AutonumericModule
  ],
  exports: [
    AgregarFichaComponent,
    ListaFichasComponent,
    MainFichaComponent
  ]
})
export class FichaColaboradorModule { }
